export enum LocationPriceStream {
  Default = 'Default',
  TaxesIn = 'TaxesIn',
  TaxesInRounded = 'TaxesInRounded'
}
